module.exports = __webpack_public_path__ + "images/cebsblogo_white.1790128953909.png";